import {
  JobClosingDocument,
  JobClosingDocumentInput,
  JobClosingExpenseLine,
  JobClosingLine,
  JobClosingPileLine,
  JobClosingStatus,
} from './types'

const mapSignedByName = (row: any): string | null =>
  row.signedByName ?? row.signerName ?? row.signedName ?? null

const mapApiItemToLine = (item: any, headId: string): JobClosingLine => {
  if (item.lineType === 'pile') {
    return {
      id: String(item.id),
      headId,
      sequence: item.sequence,
      lineType: 'pile',
      inventoryCode: item.inventoryCode ?? '',
      quantity: item.amount != null ? Number(item.amount) : 1,
      length: item.length != null ? Number(item.length) : null,
    } as JobClosingPileLine
  }
  return {
    id: String(item.id),
    headId,
    sequence: item.sequence,
    lineType: 'expense',
    description: item.description ?? '',
    amount: item.amount != null ? Number(item.amount) : null,
  } as JobClosingExpenseLine
}

export const apiListItemToSummary = (row: any): JobClosingDocument => ({
  // some backends return only URL/path without file name
  ...(() => {
    const signedFileUrl =
      row.signedFileUrl ??
      row.signedFile?.url ??
      row.signedFile?.downloadUrl ??
      row.signedFilePath ??
      null
    return {
      signedFileUrl,
      hasSignedFile: Boolean(row.hasSignedFile || row.signedFileName || signedFileUrl),
    }
  })(),
  id: String(row.id),
  documentNo: row.documentNo ?? '',
  projectId: String(row.projectId),
  createdAt: row.createdAt ?? '',
  createdBy: row.createdBy ?? '',
  status: (row.status ?? 'draft') as JobClosingStatus,
  subject: row.subject ?? '',
  addressee: row.addressee ?? '',
  companyName: row.companyName ?? '',
  remark: row.remark ?? undefined,
  issuedAt: row.issuedAt ?? null,
  signedFileName: row.signedFileName ?? null,
  signedMimeType: row.signedMimeType ?? null,
  signedFileSize: row.signedFileSize ?? null,
  signedUploadedAt: row.signedUploadedAt ?? null,
  signedByName: mapSignedByName(row),
  lines: [],
  lineCount: row.itemCount ?? 0,
})

export const apiDetailToDocument = (data: any): JobClosingDocument => {
  const id = String(data.id)
  const items = data.items ?? data.lines ?? []
  const lines = items.map((item: any) => mapApiItemToLine(item, id))
  const signedFileUrl =
    data.signedFileUrl ??
    data.signedFile?.url ??
    data.signedFile?.downloadUrl ??
    data.signedFilePath ??
    null

  return {
    id,
    documentNo: data.documentNo ?? '',
    projectId: String(data.projectId),
    createdAt: data.createdAt ?? '',
    createdBy: data.createdBy ?? '',
    status: (data.status ?? 'draft') as JobClosingStatus,
    subject: data.subject ?? '',
    addressee: data.addressee ?? '',
    companyName: data.companyName ?? '',
    remark: data.remark ?? undefined,
    issuedAt: data.issuedAt ?? null,
    signedFileName: data.signedFileName ?? null,
    signedMimeType: data.signedMimeType ?? null,
    signedFileSize: data.signedFileSize ?? null,
    signedUploadedAt: data.signedUploadedAt ?? null,
    signedByName: mapSignedByName(data),
    signedFileUrl,
    hasSignedFile: Boolean(data.signedFileName || signedFileUrl),
    lines,
    lineCount: lines.length,
  }
}

export const formInputToApiBody = (input: JobClosingDocumentInput) => ({
  subject: input.subject,
  addressee: input.addressee,
  companyName: input.companyName,
  remark: input.remark ?? null,
  items: input.lines.map(line => {
    if (line.lineType === 'pile') {
      return {
        lineType: 'pile',
        inventoryCode: line.inventoryCode,
        description: null,
        amount: line.quantity ?? 1,
        length: line.length ?? null,
      }
    }
    return {
      lineType: 'expense',
      inventoryCode: null,
      description: line.description,
      amount: line.amount ?? null,
    }
  }),
})
